import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Hand } from 'lucide-react'
import { usePageHeader } from '@meno/ui/components/layout/PageHeader'
import { TabButton } from '@meno/ui/components/shared/TabButton'
import { StopScreensPanel } from '@/pages/StopScreensPage'

// Tablet — the interactive touch-surface destination. Mirrors the Collections
// (Content) page: a flush tab strip under the TopBar with each surface as a
// tab. Stop Screens is the first tab (more touch features can slot in beside
// it later), so the page owns the header and each panel renders header-less.
type TabKey = 'stopScreens'

export default function TabletPage() {
  const { t } = useTranslation()
  usePageHeader({
    title: t('nav.tablet', 'Tablet'),
    subtitle: t('tablet.subtitle', 'Interactive touch surfaces that sit on top of your screens'),
  })

  const [active, setActive] = useState<TabKey>('stopScreens')

  const tabs = [
    { key: 'stopScreens' as const, label: t('nav.stopScreens', 'Stop Screens'), icon: Hand },
  ]

  return (
    <div className="flex flex-col gap-6 flex-1 min-h-0">
      {/* Tab strip — flush under TopBar, same -mx/-mt trick the Collections
          page uses so the strips line up identically across the app. */}
      <div className="-mx-4 sm:-mx-[var(--space-l)] -mt-1 sm:-mt-[calc(var(--space-l)-0.75rem)] mb-0 px-4 sm:px-[var(--space-l)] border-b border-border bg-transparent shrink-0">
        <div className="flex gap-1">
          {tabs.map(tb => (
            <TabButton
              key={tb.key}
              active={active === tb.key}
              onClick={() => setActive(tb.key)}
              icon={tb.icon}
              label={tb.label}
            />
          ))}
        </div>
      </div>

      {active === 'stopScreens' && <StopScreensPanel />}
    </div>
  )
}

